import { render } from "./GenogramParentsTemplateDialog.vue?vue&type=template&id=059f88ea"
import script from "./GenogramParentsTemplateDialog.vue?vue&type=script&lang=js"
export * from "./GenogramParentsTemplateDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__